export const LogoForm = Object.freeze({
  FULL: 'Full',
  SHORT: 'Short',
  ICON: 'Icon',
  NONE: '',
})
